import React, { useContext } from "react";
import { CardItemAuthorization } from "../../../components/common/CardItemAuthorization";
import UserContext from "../../../context/user-context";
import { useTranslation } from "../../../hooks/useTranslation";
import {
  markAuthorization,
  toggleAuthorization,
} from "../../../store/actions/userAction";
import { AuthorizationType } from "../../../store/types/userTypes";
import { getResidentPassInformation } from "../../../utils/Parses";
import { CompanionTabIndex, EntrantTabIndex } from "../../../utils/tabIndex";
import { CardAuthorization } from "../CardAuthorization/CardAuthorization";

enum GuestType {
  any = "any",
  provider = "provider",
}

export const GuardAuthorization = () => {
  const { t, BundleKey } = useTranslation();

  const { state, dispatch } = useContext(UserContext);

  const handleCheckBoxChange = (
    value: boolean,
    id: string,
    guestType: GuestType
  ) => {
    dispatch(markAuthorization(id, value, AuthorizationType.authorizedOnGuard));
  };

  const handleToggleChange = (value: GuestType, id: string) => {
    dispatch(
      toggleAuthorization(id, value, AuthorizationType.authorizedOnGuard)
    );
  };

  return (
    <>
      {state.authorizations?.length !== 0 &&
        state.authorizations?.find(
          (item: any) => item.type === AuthorizationType.authorizedOnGuard
        ) !== undefined ? (
        <CardAuthorization
          title={t(BundleKey.DETAIL_AUTHORIZATION_GUARD_TITLE)}
          type={AuthorizationType.authorizedOnGuard}
        >
          {state.authorizations.map((item: any, index: any) => {
            if (
              item.type === AuthorizationType.authorizedOnGuard &&
              !item.hidden
            )
              return (
                <CardItemAuthorization
                  key={index}
                  id={item.id}
                  tabIndex={
                    state.config?.companion 
                      ? CompanionTabIndex.authorizedOnGuard 
                      : EntrantTabIndex.authorizedOnGuard
                  }
                  checkValue={item.mark}
                  checkHandle={handleCheckBoxChange}
                  toggleTypeValue={item.guestType}
                  toggleTypeHandle={handleToggleChange}
                >
                  {getResidentPassInformation(item.authorization.host)}
                </CardItemAuthorization>
              );
          })}
        </CardAuthorization>
      ) : null}
    </>
  );
};
